export function init() {
    const mediaQuery = window.matchMedia('(min-width: 992px)');

    if (mediaQuery.matches) {
        hoverAnimation();
    }
}

function hoverAnimation() {
    const links = document.querySelectorAll('.text-with-links .links .link');
    links.forEach((link) => {
        link.addEventListener('mouseover', (event) => {
            const index = event.currentTarget.dataset.index;
            const imageToShow = document.querySelector(`.text-with-links .link__image[data-index="${index}"]`);
            imageToShow.classList.add('show');
        });

        link.addEventListener('mouseout', (event) => {
            const activeImage = document.querySelector(`.text-with-links .link__image.show`);
            activeImage.classList.remove('show');
        })
    })
}
